export default {
  data() {
    return {
      serviceInfoDialog: false,
      selectedService: null
    };
  },

  methods: {
    openServiceInfo(service) {
      this.selectedService = service;
      this.serviceInfoDialog = true;
    },
    closeServiceInfo() {
      this.serviceInfoDialog = false;
    },
    getServiceDescription(service) {
      if (!service || !service.description) {
        return "";
      }
      const locale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : "es";
      if (service.description[locale]) {
        return service.description[locale];
      }
      return (
        service.description.es ||
        service.description.en ||
        service.description.gl ||
        ""
      );
    },
    isServiceAvailableInForms(service) {
      return !service || service.available_in_forms !== false;
    },
    filterUnavailableFormServices(serviceIds, services) {
      if (!Array.isArray(serviceIds)) {
        return [];
      }
      if (!Array.isArray(services) || services.length === 0) {
        return [...new Set(serviceIds)];
      }
      return [...new Set(serviceIds)].filter(id => {
        const service = services.find(item => item && item.id === id);
        return !service || this.isServiceAvailableInForms(service);
      });
    }
  }
};
